import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SystemSettingsService {

  constructor(private http: HttpClient) { }

  getSettings(): Observable<any> {
    return this.http.post(environment.baseUrl + '/' + environment.app + '/settings/get', '');
  }

  saveSettings(settings: any): Observable<any> {
    return this.http.post(environment.baseUrl + '/' + environment.app + '/settings/save', settings);
  }
}
